<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 class="extra-large-text">დაამატეთ ოფისი</h5>
        <form class="add-organization-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="addOffices">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="officeName" class="ms-2">ოფისის სახელი(ქართულად)</label>
            <input v-model="officeDataVModels.office_name" type="text" autocomplete="off" name="officeName" id="officeName" required placeholder="ოფისის სახელი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="officeEngName" class="ms-2">(ინგლისურად)ოფისის სახელი</label>
            <input v-model="officeDataVModels.office_nameeng" type="text" autocomplete="off" name="officeEngName" id="officeEngName" required placeholder="(ინგლისურად)ოფისის სახელი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="officeAddress" class="ms-2">ოფისის მისამართი(ქართულად)</label>
            <input v-model="officeDataVModels.address" type="text" autocomplete="off" name="officeAddress" id="officeAddress" required placeholder="ოფისის მისამართი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="officeEngAddress" class="ms-2">(ინგლისურად)ოფისის მისამართი</label>
            <input v-model="officeDataVModels.addresseng" type="text"  autocomplete="off" name="officeEngAddress" id="officeEngAddress" required placeholder="(ინგლისურად)ოფისის მისამართი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="description" class="ms-2">აღწერა(ქართულად)</label>
            <textarea v-model="officeDataVModels.description" type="text"  autocomplete="off" rows="5" name="description" id="description" required placeholder="აღწერა(ქართულად)" class="blue-part-input large-text"></textarea>
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="descriptionEng" class="ms-2">(ინგლისურად)აღწერა</label>
            <textarea v-model="officeDataVModels.descriptioneng" type="text" autocomplete="off" rows="5" name="descriptionEng" id="descriptionEng" required placeholder="(ინგლისურად)აღწერა" class="blue-part-input large-text"></textarea>
          </fieldset>
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="officeNumber" class="ms-2">ოფისის ტელეფონის ნომერი</label>
            <input v-model="officeDataVModels.phone" type="text" autocomplete="off" name="officeNumber" id="officeNumber" required placeholder="ოფისის ტელეფონის ნომერი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end justify-content-center gap-1 light-gray-color light-text">
            <label for="isMain" class="ms-2">გსურთ დაამატოთ, როგორც მთავარი?</label>
            <input v-model="officeDataVModels.is_main" type="checkbox" autocomplete="off" name="isMain" id="isMain" class="blue-part-input large-text">
          </fieldset>
          
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
export default {
  data(){
    return {
      officeDataVModels: {
        office_name: "",
        office_nameeng: "",
        address: "",
        addresseng: "",
        description: "",
        descriptioneng: "",
        phone: "",
        is_main: false,
      },
      isSending: false,
    }
  },
  components: {
    secondaryButton,
  },
  methods: {
    
    addOffices(){
      // let isNameValid = this.$helper.checkString(this.officeDataVModels.office_name);
      // let isEngNameValid = this.$helper.checkEngString(this.officeDataVModels.office_nameeng);
      // let isAddressValid = this.$helper.checkString(this.officeDataVModels.address);
      // let isAddressEngValid = this.$helper.checkEngString(this.officeDataVModels.addresseng);
      // let isDescriptionValid = this.$helper.checkString(this.officeDataVModels.description);
      // let isDescriptionEngValid = this.$helper.checkEngString(this.officeDataVModels.descriptioneng);
      // let isPhoneNumberValid = this.$helper.checkJustString(this.officeDataVModels.phone);

      let isCheckBoxValid = typeof(this.officeDataVModels.is_main) == "boolean"? true: false;

      if(this.officeDataVModels.office_name && this.officeDataVModels.office_nameeng && this.officeDataVModels.address && this.officeDataVModels.addresseng
         && this.officeDataVModels.description && this.officeDataVModels.descriptioneng && this.officeDataVModels.phone && isCheckBoxValid){
        this.isSending = true;
        const formData = new FormData();
        for(let key of Object.keys(this.officeDataVModels)){
          if(key == "phone"){
            formData.append(key, this.officeDataVModels[key]);
          }else if(key == "is_main"){
            formData.append(key, this.officeDataVModels[key]?1:0);
          }else{
            formData.append(key, this.officeDataVModels[key]);
          }
        }
        // for(let entries of formData.entries()){
        //   console.log(entries);
        // }
        
        
        this.$store.dispatch("addOffices", formData).then((response) => {
          if(response.status == 201){
            this.$helper.showSwal("ოფისი წარმატებით დაემატა", "success", "");
            setTimeout(() => {this.$router.go()}, 1500);
          }
        }).catch((error) => {
          if(error?.response?.status == 422){
            this.$helper.showSwal("მოხდა შეცდომა", "error", "");
            setTimeout(() => {this.$router.go()}, 1500);
          }
        }).finally(() => {
          this.isSending = false;
        })
      }
    }
  }
}
</script>
<style scoped>
input[type="checkbox"]{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(1, min-content);
  row-gap: 1.5em;
}
.add-organization-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper{
  grid-column: 1/3;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}


@media screen and (max-width: 1800px) {
  .add-organization-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 3em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-organization-form{
    width: 90%;
  }
}
</style>
